/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';
import type { Block } from '@intercom/interblocks.ts';

export default class DynamicContentVariation extends Fragment {
  @attr declare locale: string;
  @attr declare textContent: string;
  @attr() declare jsonBlocks: Block[];
}
